import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "mileage-log",
      path: "mileage-log/:filter?",
      meta: {
        auth: () => store.getters.isEmployee(),
        icon: "mileage",
        title: i18n.global.t("Mileage Log"),
        crumbs: ["sales-tools"],
      },
      component: () => import("pages/employee/MileageLog"),
    },
  ],

  dialogs: [
    {
      name: "mileage-log-view",
      path: "/sales-tools/mileage-log/:logID/view",
      props: true,
      meta: {
        auth: () => store.getters.isEmployee(),
        icon: "mileage",
        title: i18n.global.t("Mileage Entry"),
        color: "primary",
      },
      component: () => import("../../../dialogs/employee/MileageLogView"),
    },
    {
      name: "mileage-log-new",
      path: "/sales-tools/mileage-log/new",
      props: true,
      meta: {
        auth: () => store.getters.isEmployee(),
        icon: "mileage",
        title: i18n.global.t("New Mileage Entry"),
        color: "primary",
      },
      component: () => import("../../../dialogs/employee/MileageLogEdit"),
    },
    {
      name: "mileage-log-edit",
      path: "/sales-tools/mileage-log/:logID/edit",
      props: true,
      meta: {
        auth: () => store.getters.isEmployee(),
        icon: "mileage",
        title: i18n.global.t("Edit Mileage Entry"),
        color: "primary",
      },
      component: () => import("../../../dialogs/employee/MileageLogEdit"),
    },
  ],
};
